import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dept",
  "use": "dept-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"dept\"><path fill=\"#37F\" fill-rule=\"nonzero\" d=\"m11.197 7.146-.017-2.338H7.684V3.332h3.691v-1.64h-8.75v1.64h3.692v1.476H2.84v2.338h-1.55v5.185h4.427V7.146h-1.51v-.97h5.614l.008.97H8.264v5.185h4.427V7.146z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol